<!-- 采购历史详情 -->
<template>
  <cc-container class="purchase-detail">
    <cc-header-nav title="采购计划详情"></cc-header-nav>
    <cc-main>
      <ul class="word-list">
        <li>采购计划单号：{{options.plan_order_number}}</li>
        <li>订单状态：{{options.state | getState}}</li>
        <li>下单时间：{{options.created_date | $getDate}}</li>
        <li>制单人：{{options.salesman}}</li>
        <li v-if="+options.state === 1">审核人：{{options.buyer}}</li>
        <li class="pt5 pb5">备注：{{options.remark}}</li>
      </ul>
      <ul class="product-list">
        <template v-if="list.length>0">
          <li v-for="(item,index) in list" :key="index">
            <div class="left">
              <img :src="item.img" alt="">
            </div>
            <ul class="center">
              <li>{{item.general_name}}</li>
              <li>{{item.norms}}</li>
              <li>{{item.factory}}</li>
              <li><van-tag type="danger" color="#F92D6C">供</van-tag> {{item.supplier}}</li>
              <li>采购价：￥{{item.price}} </li>
            </ul>
            <div class="right">
              <p>购买数量：{{item.quantity}}</p>
            </div>
          </li>
        </template>

        <li style="height:40px;overflow:hidden;margin-top:8px">
          <div style="float:left">总计<span style="color:#F92D6C">￥{{options.total_price}}</span></div>
          <div style="float:right">数量共：{{options.total_num}}</div>
        </li>
      </ul>
    </cc-main>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { Tag } from 'vant'
import { getPurchaseHistoryInfo } from '~fetch/manage-center/purchase'
import { ResultCode } from '~const/ResultCode'
Vue.use(Tag)
export default {
  name: 'purchase-history-detail',
  components: {},

  data () {
    return {
      options: {
        plan_order_number: '',
        created_date: '',
        remark: '',
        state: '',
        buyer: '',
        salesman: '',
        total_price: '',
        total_num: ''
      },
      list: []
    }
  },

  computed: {},

  created () {
    this.loadData()
  },

  methods: {
    /**
     * @description 加载订单详情
     */
    async loadData () {
      const params = {
        plan_order_id: this.$route.params.id
      }
      let { status, data } = await getPurchaseHistoryInfo(params)
      if (status === ResultCode.SUCCESS) {
        this.$mapData(this.options, data) // 全局mixins整理数据
        this.options.buyer = data.manager && data.manager.nickname
        this.options.salesman = data.member && data.member.nickname
        this.options.total_num = data.planOrderGoods.reduce((total, next) => {
          return total + parseInt(next.quantity)
        }, 0)
        let list = data.planOrderGoods.map(item => {
          return {
            id: item.id,
            general_name: item.general_name,
            norms: item.norms,
            supplier: item.supplier,
            price: item.price,
            quantity: item.quantity,
            factory: item.factory,
            img: (item.image_list && item.image_list[0]) || this.$notImg
          }
        })
        this.list = Object.freeze(list)
      }
    }

  },
  filters: {
    /**
     * @description 返回状态
     */
    getState (value) {
      if (!value) return ''
      let item = value.toString()
      switch (item) {
        case '0':
          return '待审核'
        case '1':
          return '已审核'
        case '2':
          return '已拒绝'
        case '3':
          return '已取消'
      }
    }
  }
}
</script>
<style lang='scss' scoped>
@import "~styles/mixins.scss";
.purchase-detail {
  font-size: 12px;
  .word-list {
    background: #ffffff;
    box-shadow: $box-shadow-base;
    margin-bottom: 8px;
    >li {
      min-height: 40px;
      display: flex;
      align-items: center;
      padding-left: 31px;
      padding-right: 31px;
      border-bottom: 1px solid rgba(238, 238, 238, 1);
      word-break: break-all;
      /* @include ell() */
    }
  }
  .product-list {
    >li {
      background: #ffffff;
      box-sizing: border-box;
      width: 100%;
      height: 104px;
      padding: 10px;
      box-shadow: $box-shadow-base;
      overflow: hidden;
      .left{
        width: 84px;
        height: 84px;
        box-sizing: border-box;
        padding: 1px;
        border:1px solid rgba(229,229,229,1);
        float: left;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .center{
        float: left;
        height: 100%;
        width: 170px;
        margin-left: 15px;
        display: flex;
        flex-direction:column;
        justify-content: center;

        li{
          width: 170px;
          overflow: hidden;/*超出部分隐藏*/
          white-space: nowrap;/*不换行*/
          text-overflow:ellipsis;/*超出部分文字以...显示*/
        }
        .num{
          float: center;
        }

      }
      .right{
        float: right;
        height: 100%;
        display: flex;
        flex-direction:column-reverse;
      }
      >div{
        height: 100%;
      }
    }
  }
}
</style>
